import React from 'react';
import { FormDropdown, Header, Segment } from 'semantic-ui-react';

class IFACEBounds extends React.Component {
  constructor(props) {
    super(props);

    this.boundListUpdate = this.boundListUpdate.bind(this);
    this.boundValueUpdate = this.boundValueUpdate.bind(this);
  }

  boundListUpdate(e, d) {
    //const {boundList} = this.state;
    let oldList = this.props.defaultValue === undefined ? [] : this.props.defaultValue;
    let newList = [];
    for (let i=0; i < d.value.length; i++) {
      let targ = d.value[i];
      let val = 7;
      // Double loop to find value, because SOMEONE made a terrible mess of this structure
      for (let j=0; j < oldList.length; j++){
        if (oldList[j][targ] !== undefined) {
          val = oldList[j][targ];
        }
      }
      newList.push({ [targ] : val});
    }
    d.name = "IFACE";
    d.value = newList;
    this.props.onChange(e,d);
  }

  boundValueUpdate(e, d) {
    //const {boundList} = this.state;
    let boundList = this.props.defaultValue === undefined ? [] : this.props.defaultValue;
    // Now to just change the value of the object in the list through a roundabout means
    boundList[d.boundid][Object.keys(boundList[d.boundid])[0]] = d.value;
    d.name = "IFACE";
    d.value = boundList;
    this.props.onChange(e,d);
  }

  getBounds(boundList) {
    let items = [];
    for (let i=0; i < boundList.length; i++){
      // Only ONE key per object, since SOMEONE set it up that way
      items.push(Object.keys(boundList[i])[0]);
    }
    return items;
  }

  render() {
    const boundList = this.props.defaultValue === undefined ? [] : this.props.defaultValue;
    const boundaries = this.props.boundaries.map((lab,index) =>
      ({key: index, text: lab, value: lab}));
    const currentItems = this.getBounds(boundList);
    return(
      <div>
        <FormDropdown multiple selection
                      name = "IFACE"
                      placeholder='Select one or more'  
                      options={boundaries}
                      value={currentItems}
                      onChange={this.boundListUpdate}/>
        {boundList.length > 0 && <Header size="tiny">IFACE Values</Header>}
        {boundList.length > 0 && <IFACEBoundVals iface={this.props.iface} boundList={boundList} onChange={this.boundValueUpdate}/>}
      </div>
    )
  }
}

class IFACEBoundVals extends React.Component {

  returnIfaceDD = this.returnIfaceDD.bind(this);

  returnIfaceDD(obj, index) {
    const iface = this.props.iface.map((lab,index) =>
        ({key: index, text: lab, value: lab}));
    const label = Object.keys(obj)[0];
    const val = obj[label];
    return(<FormDropdown label={label} inline
                         options={iface}
                         defaultValue={val}
                         key={index}
                         boundid={index}
                         onChange={this.props.onChange}/>)
  }

  render() {
    const ifaceDD = this.props.boundList.map((obj,index) =>
      this.returnIfaceDD(obj, index));
    return(
      <Segment attached>{ifaceDD}</Segment>
    )
  }

}

export default IFACEBounds;